import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../contexts/auth/Context";
import { isSuperAdminRole, isTrainerRole } from "../../contexts/auth/utils";
import { getCurrentGymRequest } from "../requests/gym";

const CURRENT_GYM_QUERY_KEY = ["gym", "current"] as const;

export const useCurrentGym = () => {
  const { token } = useAuth();
  const isSuperAdmin = isSuperAdminRole(token);
  // El entrenador no tiene gimnasio y `GET /gym/current` le responde 400, no 404,
  // asi que sin esto el manejador global de errores tira un toast rojo al montar
  // y en cada foco de ventana.
  const isTrainer = isTrainerRole(token);

  return useQuery({
    queryKey: CURRENT_GYM_QUERY_KEY,
    queryFn: () => getCurrentGymRequest(token!),
    enabled: !!token && !isSuperAdmin && !isTrainer,
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};
